import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import git from '../assets/img/git.svg';
import react from '../assets/img/react.svg';
import java from '../assets/img/java.svg';
import javascript from '../assets/img/javascript.svg';
import python from '../assets/img/python.svg';
import spring from '../assets/img/spring.svg';
import mongodb from '../assets/img/mongodb.svg';
import nextjs from '../assets/img/nextjs.svg';
import nodejs from '../assets/img/nodejs.svg';
import about from '../assets/contents/about.json';

export const About = () => {
    const logos = [java, python, javascript, git, spring, mongodb, nextjs, nodejs, react];

    return(
        <section id="about">
            <Container className="text-start">
                <Row>
                <div className="section-header">about</div>
                </Row>
                <div className="about-copy-grid">
                    <div className="pg-box about-software">
                        <h2 className="pg-title">software</h2>
                        <p className="paragraph">{about.software}</p>
                    </div>
                    <div className="pg-box about-longevity">
                        <h2 className="pg-title">longevity</h2>
                        <p className="paragraph">{about.longevity}</p>
                    </div>
                    <div className="pg-box about-biology">
                        <h2 className="pg-title">biology</h2>
                        <p className="paragraph">{about.biology}</p>
                    </div>
                    <div className="pg-box about-hobbies">
                        <h2 className="pg-title">hobbies</h2>
                        <p className="paragraph">{about.outside}</p>
                    </div>
                </div>
                <Row>
                    <Col className="skill-row">
                        <h2 className="pg-title">my skills</h2>
                        <div className="skill-box">
                            <div className="skill-slider">
                                <div className="skill-track">
                                    {[...logos, ...logos].map((item, index) => (
                                        <div className="skill-item" key={index}><img src={item} alt="Logo" width={150}/></div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}